import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterCallback',
    standalone: true
})
export class FilterCallbackPipe implements PipeTransform {

	transform(items: Array<any>, callback: (item: any) => void): Array<any> {
		if (!items || !callback) return items;

		return items.filter((item: any) => callback(item));
	}
}
